import { getLocalStorage } from '@common/utils/localStorage/getLocalStorage'
import type { PopupStorageData } from './getUpdatedStorageData'

export const getPopupStorageData = (pagePopupId: number) => {
    const popupStorageData = getLocalStorage<PopupStorageData[]>('popup-data')
    const singlePopupStorageData = popupStorageData?.find(popup => popup.id === pagePopupId)
    return { singlePopupStorageData, popupStorageData }
}

export default getPopupStorageData
